import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { AbcPopupComponent, _AbcButtonComponent, _AbcSwitchComponent } from '@barthauer/abc/ui-components';

import { NotificationMessage, ToastType } from '@barthauer/custom/xmt-models';
import { ReplaySubject, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { DataService, ObjectKeys } from '../../../services/data.service';
import { PersistMode } from '@barthauer/abc/core/data';
import { ToastService } from '../../../services/toast.service';

export interface INotificationSettings {
  Id: string;
  Identifier: string;
  Category: string;
  Title: string;
  Text: string;
  IsActive: boolean;
}

@Component({
  selector: 'notification-settings',
  templateUrl: './notification-settings.component.html',
  styleUrls: ['./notification-settings.component.scss'],
  imports: [
    _AbcButtonComponent,
    _AbcSwitchComponent,
    AbcPopupComponent,
    CommonModule,

    FlexLayoutModule,
  ],
  encapsulation: ViewEncapsulation.None
})
export class NotificationSettingsComponent implements OnInit, OnDestroy {
  @ViewChild('notificationSettingsPopup', { static: false }) notificationSettingsPopup: AbcPopupComponent;

  @Input()
  protected set notificationSettings(value: INotificationSettings) {
    if (value) {
      this.notificationSettings$.next(value);
    }
  }

  @Output() updateNotificationSettings: EventEmitter<boolean> = new EventEmitter<boolean>();

  private subscriptions: Subscription[] = [];
  private notificationSettings$ = new ReplaySubject<INotificationSettings>(1);

  private readonly toastService = inject(ToastService);



  protected showLoader: boolean = false;

  public notificationSettingsData: INotificationSettings;

  constructor(
    public aimsDataservice: DataService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.notificationSettings$.subscribe((settings) => {
        this.notificationSettingsData = settings;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public showPopup(): void {
    this.notificationSettingsPopup.instance.show();
  }

  protected hidePopUp(): void {
    this.notificationSettingsPopup.instance.hide();
  }
  protected turnOnOff() {
    this.showLoader = true;

    this.subscriptions.push(
      this.aimsDataservice
        .persistObject(
          PersistMode.Update,
          ObjectKeys.REMINDER,
          [this.aimsDataservice.coreDataService.createPersistTargetColumn(
            "IsActive", this.notificationSettingsData.IsActive)],
          this.notificationSettingsData.Id
        )
        .pipe(
          finalize(() => {
            this.showLoader = false;
          })
        )
        .subscribe({
          next: () => {
            this.updateNotificationSettings.emit(this.notificationSettingsData.IsActive);
            this.hidePopUp();
            this.toastService.toast(this.aimsDataservice.res(NotificationMessage.UpdatedSuccessfully), ToastType.SUCCESS);
          },
          error: () => {
            this.toastService.toast(NotificationMessage.ErrorSomethingWentWrong, ToastType.ERROR);
          },
        })
    );
  }
}
